import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { useOrganizationAlias } from "@domain/currentProfile/hooks";
import { PostComment } from "@domain/post/comment/postComment";
import { useCommentReplies } from "@domain/post/hooks";
import { Person } from "@domain/user/user";
import { gap } from "@ui/styles/utils";
import { CommentView, PostCommentSkeleton } from "./commentView";

interface RepliesViewProps extends React.HTMLAttributes<HTMLDivElement> {
	postId: string;
	parentId: string;
	replyTo?: Person;
	onReply?: (to: Person) => void;
	lastReply?: PostComment;
}
export const RepliesView: React.FC<RepliesViewProps> = ({
	postId,
	parentId,
	replyTo,
	onReply,
	lastReply,
	...htmlProps
}) => {
	const alias = useOrganizationAlias();
	const { result: replies, loading, fetchMore, totalElements } = useCommentReplies(parentId, alias?.id);

	return (
		<div {...htmlProps}>
			{loading ? (
				<PostCommentSkeleton />
			) : (
				<Replies>
					{replies.reverse().map((reply) => (
						<CommentView key={reply.id} postComment={reply} postId={postId} replyTo={replyTo} onReply={onReply} />
					))}
				</Replies>
			)}
			{replies.length < 1 && lastReply && (
				<CommentView key={lastReply.id} postComment={lastReply} postId={postId} replyTo={replyTo} onReply={onReply} />
			)}
			{totalElements !== undefined && totalElements > replies.length && (
				<FetchMoreReplies onClick={fetchMore}>{I18n.t("post.comment.more_replies")}</FetchMoreReplies>
			)}
		</div>
	);
};

const Replies = styled.div`
	${gap(6)};
`;

const FetchMoreReplies = styled.div`
	cursor: pointer;
	${({ theme }) => theme.textStyles.label};
`;
